module.exports = __webpack_public_path__ + "img/type3.9e892c8a.png";